import { styled } from '@magal/styles'
import { FC, ReactNode } from 'react'
import { useProductsSettings } from '@magal/product'

const TagsContainer = styled('div', {
  zIndex: '10',
  position: 'absolute',
  padding: '$12',
  display: 'flex',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  // maskImage:
  //   'linear-gradient(to left, rgba(0, 0, 0, 0) 5%, rgba(0, 0, 0, 1) 10%)',
  gap: '$8',
  width: '100%',
  '@lg': {
    padding: '$16 $16',
  },
})

interface TagProps {
  children: ReactNode
  style?: React.CSSProperties
}

const StyledTag = styled('div', {
  backgroundColor: '$green',
  padding: '$4 $8',
  projectFont: 'caps07',
  fontSize: '11px',
  color: '$white',
  borderRadius: '4px',
  lineHeight: 1.2,
  '@lg': {
    padding: '$6 $8 $4',
    fontSize: '12px',
  },
})

const Tag: FC<TagProps> = ({ children, style }) => {
  return <StyledTag style={style}>{children}</StyledTag>
}

type ProductTagsProps = {
  tags?: string[]
  position?: 'left' | 'right'
}
export const ProductTags: FC<ProductTagsProps> = ({
  tags,
  position = 'left',
}) => {
  const { tagsConfig } = useProductsSettings()
  const colorWithDefault = (color: string, defaultColor: string) =>
    color ? color : defaultColor

  if (!tags || tags.length < 1 || !tagsConfig) {
    return null
  }

  return (
    <TagsContainer
      style={{
        justifyContent: position === 'right' ? 'flex-end' : 'flex-start',
      }}
    >
      {tags.map((tag: string, i) => {
        if (tagsConfig[tag])
          return (
            <Tag
              key={i}
              style={{
                backgroundColor: colorWithDefault(
                  tagsConfig[tag].bgColor,
                  'var(--colors-green)',
                ),
                color: colorWithDefault(tagsConfig[tag].textColor, '#ffffff'),
              }}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: tagsConfig[tag].label,
                }}
              />
            </Tag>
          )
        return null
      })}
    </TagsContainer>
  )
}
